import { createSlice } from "@reduxjs/toolkit";

export const ThemeSlice = createSlice({
  name: "setTheme",
  initialState: 'light',
  reducers: {
    setupTheme: (state, action) => {
      return action.payload;
    },
  },
});

// this is for dispatch
export const { setupTheme } = ThemeSlice.actions;

// this is for configureStore
export default ThemeSlice.reducer;
